var _defs, _polygon, _polygon2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew297({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "13.93 7.96 7.96 4.52 7.96 11.41 13.93 7.96"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "6.97 7.96 1 4.52 1 11.41 6.97 7.96"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15,
    y1: 3.54,
    x2: 15,
    y2: 12.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew297);
export default __webpack_public_path__ + "static/media/Symbolpack_New_297.a2d67928a917bd001ebaa510c871fd7a.svg";
export { ForwardRef as ReactComponent };